import { Deck } from './deck';

export class DeckGroup {
    public Name: string;
    public Decks: Deck[];
}
